import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const WeddingContext = createContext(null);

export function WeddingProvider({ children }) {
  const [wedding, setWedding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState("idle");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/wedding");
      setWedding(data.wedding);
    } catch {
      setWedding(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async (patch) => {
    setSaveStatus("saving");
    setWedding((w) => ({ ...w, ...patch }));
    try {
      const { data } = await api.put("/wedding", patch);
      setWedding(data.wedding);
      setSaveStatus("saved");
      setTimeout(() => setSaveStatus("idle"), 1500);
    } catch {
      setSaveStatus("error");
    }
  };

  return (
    <WeddingContext.Provider value={{ wedding, setWedding, loading, save, saveStatus, load }}>
      {children}
    </WeddingContext.Provider>
  );
}

export const useWedding = () => useContext(WeddingContext);
